module.exports = __webpack_public_path__ + "media/icons/attachment_icon-bb95cab5.png";